import type { AppDirectClient } from '../client.js';
import { AuthError } from '../errors.js';
import { ensureValidFeJwt } from '../session/ensure-fejwt.js';
import { getUserFromFeJwt } from '../session/jwt.js';
import type { RefreshCoordinator } from '../session/refresh-coordinator.js';
import type { MeResult, ResolvedConfig } from '../types.js';

export function getUserFromSession(input: {
  sessionToken: string | null | undefined;
}): MeResult {
  const token = input.sessionToken ?? null;
  const user = getUserFromFeJwt(token);

  return {
    user,
    hasSession: !!token,
  };
}

export async function getMe(
  config: ResolvedConfig,
  client: AppDirectClient,
  coordinator: RefreshCoordinator,
  input: {
    sessionToken: string | null | undefined;
    refreshToken?: string | null;
  },
): Promise<MeResult> {
  const sessionToken = input.sessionToken ?? null;
  const refreshToken = input.refreshToken ?? null;

  if (!sessionToken && !refreshToken) {
    return { user: null, hasSession: false };
  }

  try {
    const jwtResult = await ensureValidFeJwt(config, client, coordinator, {
      sessionToken,
      refreshToken,
    });
    const user = getUserFromFeJwt(jwtResult.token);

    return {
      user,
      hasSession: true,
      cookiesToSet: jwtResult.cookiesToSet,
    };
  } catch (err) {
    if (err instanceof AuthError) {
      return { user: null, hasSession: false };
    }
    throw err;
  }
}
